import { useEffect, useState } from 'react';
import EnglishData from '../config/en.json';
import spanishData from '../config/es.json'
import { getStoredValue } from '../_helpers/storagehelper';

const TranslateFile = () => {
    const storedlang = getStoredValue("lang");
    const [currentLang, setCurrentLang] = useState(EnglishData);

    useEffect(() => {
        switch (storedlang) {
            case 'en':
                setCurrentLang(EnglishData);
                break;
            case 'es':
                setCurrentLang(spanishData);
                break;
            default:
                setCurrentLang(EnglishData);
                break;
        }
    }, [storedlang]);

    return currentLang;
};

export default TranslateFile;




